import viewPassword from "../../utils/viewPassword"
import areTheFieldsFilled from "../../utils/areTheFieldsFilled";


window.Drupal.behaviors.configMeals = {
  attach: (context) => {
    window.addEventListener("DOMContentLoaded", () => {
      areTheFieldsFilled(
        [ // input's ID o Class
          ['#user-login-form #edit-name', '#user-login-form #edit-pass'],
          ['.recovery-user-form #edit-name'],
          ['#edit-new-password', '#edit-new-password-confirm']
        ],
        [// Button's ID o Class
          ['.login-user-form-btn'],
          ['.recovery-user-form-btn'],
          ['.recovery-user-form-btn']
        ]
      )

      viewPassword([
        { inputId: '#user-login-form #edit-pass', iconId: '#login-password-icon' },
        { inputId: '.recovery-user-form #edit-new-password', iconId: '#recovery-password-icon' },
        { inputId: '.recovery-user-form #edit-new-password-confirm', iconId: '#recovery-new-password-icon' }
      ]);
    })
  }
}